import { useCallback, useState } from "react";
import axiosInstance from "../../../CommonMethhods/axiosInstance";
import { ACCRUAL_REPORT } from "../../../Configuration/API_URL";
import {
  ApiResDecrypt,
  decryptString,
} from "../../../CommonMethhods/CommonMethods";
import { Constants } from "../../../CommonMethhods/Constants";

const getAccrualChargesReportData = async (payload) => {
  const response = await axiosInstance.post(ACCRUAL_REPORT.data, payload);
  return response.data;
};

export const useAccrualReport = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  const fetchAccrualChargesReportData = useCallback(async (payload) => {
    const decryptedPayload = decryptString(payload);
    const parsed = JSON.parse(decryptedPayload);
    const { PageNo } = parsed;

    setIsLoading(true);
    setError("");

    try {
      const response = await getAccrualChargesReportData(payload);
      const decryptedResponse = ApiResDecrypt(response);

      if (decryptedResponse.status === 0) {
        setData((prev) => {
          if (PageNo === 1) {
            return decryptedResponse.data;
          }

          return {
            ...decryptedResponse.data,
            itemizedList: [
              ...(prev?.itemizedList || []),
              ...(decryptedResponse.data?.itemizedList || []),
            ],
          };
        });
      } else if (decryptedResponse.status === 1) {
        setError(decryptedResponse.message);
      } else {
        setError(Constants.GENERIC_ERROR_MESSAGE);
      }
    } catch (error) {
      console.error(error);
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { isLoading, data, error, fetchAccrualChargesReportData };
};

export const useAccrualActionButtons = () => {
  const [isLoading, setIsLoading] = useState({
    excel: false,
    pdf: false,
  });

  const downloadReportFile = async (payload) => {
    const decryptedPayload = decryptString(payload);
    const parsed = JSON.parse(decryptedPayload);
    const { fileType } = parsed;

    setIsLoading((prevState) => {
      return {
        ...prevState,
        [fileType]: true,
      };
    });

    try {
      const response = await getAccrualChargesReportData(payload);
      const decryptedResponse = ApiResDecrypt(response);

      if (decryptedResponse.status === 0) {
        return { success: true, data: decryptedResponse };
      }
      if (decryptedResponse.status === 1) {
        return { success: false, data: decryptedResponse };
      }
      return { success: false, data: null };
    } catch (error) {
      console.error(error);
      return { success: false, data: null };
    } finally {
      setIsLoading((prevState) => {
        return {
          ...prevState,
          [fileType]: false,
        };
      });
    }
  };

  return { isLoading, downloadReportFile };
};
